import { ListItem } from '@mui/material';
import ListItemButton, {
  type ListItemButtonProps,
} from '@mui/material/ListItemButton';
import { ComponentProps } from 'react';

export const defaultListItemStyles = 'w-auto h-7 px-2 mx-2 my-1 rounded-[5px]';
export const newSidebarListItemStyles =
  'w-auto h-[30px] px-2 mx-2 rounded-[5px]';

type DynamicListItemAsButton = {
  button: true;
  htmlId: string;
} & Omit<
  ListItemButtonProps,
  'button' | 'children' | 'component' | 'dense' | 'disableRipple' | 'classes'
> & {
    children?: React.ReactNode;
  };

type DynamicListItemAsList = {
  button: false;
  htmlId: string;
} & Omit<ComponentProps<typeof ListItem>, 'button'>;

export type DynamicListItemProps =
  | DynamicListItemAsButton
  | DynamicListItemAsList;

export const DynamicListItem = (props: DynamicListItemProps) => {
  if (props.button) {
    const {
      button: _b,
      children,
      disabled,
      htmlId,
      className,
      ...listItemButtonRest
    } = props;

    return (
      <ListItemButton
        {...listItemButtonRest}
        disableRipple
        disabled={disabled}
        id={htmlId}
        data-testid={htmlId}
        className={className}
      >
        {children}
      </ListItemButton>
    );
  }

  const {
    button: _b,
    children,
    disabled,
    htmlId,
    classes,
    className,
    ...listItemRest
  } = props;

  const sharedProps: Pick<
    DynamicListItemAsList,
    'disabled' | 'id' | 'data-testid' | 'classes' | 'className'
  > = {
    disabled,
    id: htmlId,
    'data-testid': htmlId,
    classes,
    className,
  };

  return (
    <ListItem
      component="li"
      {...sharedProps}
      {...listItemRest}
      className={className}
    >
      {children}
    </ListItem>
  );
};
